import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// Firebase project config
const firebaseConfig = {
  apiKey: 'AIzaSyBFc0Pkq8WddxhpV6E0TToinOS-UIAkKzs',
  authDomain: 'wisestepnotifications.firebaseapp.com',
  projectId: 'wisestepnotifications',
  storageBucket: 'wisestepnotifications.appspot.com',
  messagingSenderId: '866363744398',
  appId: '1:866363744398:web:b3147623272d713497e9df',
};

// Initialize Firebase app and messaging
let firebaseApp;
let messagingInstance;

try {
  firebaseApp = initializeApp(firebaseConfig);
  messagingInstance = getMessaging(firebaseApp);
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
}

export const messaging = messagingInstance;
